import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AccessRequest, ApprovalResult, InviteLink } from '../auth/auth.models';

/** Chamadas do control-plane (super-admin). */
@Injectable({ providedIn: 'root' })
export class PlatformService {
  private readonly http = inject(HttpClient);

  listAccessRequests(status?: string): Observable<AccessRequest[]> {
    const query = status ? `?status=${status}` : '';
    return this.http.get<AccessRequest[]>(`/api/platform/access-requests${query}`);
  }

  approve(id: number): Observable<ApprovalResult> {
    return this.http.post<ApprovalResult>(`/api/platform/access-requests/${id}/approve`, {});
  }

  reject(id: number): Observable<void> {
    return this.http.post<void>(`/api/platform/access-requests/${id}/reject`, {});
  }

  /** Gera de novo o link de convite de uma solicitação já aprovada (o da aprovação não se recupera). */
  resendInvite(id: number): Observable<InviteLink> {
    return this.http.post<InviteLink>(`/api/platform/access-requests/${id}/invite`, {});
  }
}
